import React from 'react'

import BkFlowEnhancementsCardDescription from '../elements/BkFlowEnhancementsCardDescription'
import BkFlowRoomEnhancementButton from '../BkFlowRoomEnhancementButton'
import formatPrice from '../../../utilities/currency/formatPrice'

import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_ENHANCEMENTS_CARD_LAYOUT === 'full') {
  require('../../../styles/css/components/enhancements/layouts/bk-flow-enhancements-card-full.css')
}

const BkFlowEnhancementsCardFull = props => {
  const {
    activeRoom,
    currencySymbol,
    currentEnhancementKey,
    enhancementCardType,
    enhancementImageSrc,
    enhancementKey,
    enhancementPrice,
    handleToggleServiceDescription,
    hotelLabels,
    isEnhancementSelected,
    keyedDetails,
    roomGroupKey,
    serviceDescriptionExpanded
  } = props

  return (
    <div
      className={isEnhancementSelected ? 'bk-flow-enhancements__card card-full active' : 'bk-flow-enhancements__card card-full inactive' }
      key={enhancementCardType[enhancementKey].serviceInventoryCode + '-' + enhancementKey}
    >
      { yn(process.env.REACT_APP_COMPONENT_ENABLE_ENHANCEMENTS_IMAGE) &&
        <div
          className="bk-flow-enhancements__card-image u-bg-image"
          style={{backgroundImage: 'url(' + enhancementImageSrc + ')'}}
        >
          <img
            className="u-element-hidden"
            src={ enhancementImageSrc }
            alt="Coming Soon"
          />
        </div>
      }

      <div className="bk-flow-enhancements__card-data">
        { keyedDetails.title ?
          <h4>{ keyedDetails.title.text }</h4>
        :
          <h4>{ hotelLabels.enhancement ? hotelLabels.enhancement : 'Enhancement'} : { enhancementCardType[enhancementKey].serviceInventoryCode }</h4>
        }

        { keyedDetails.description &&
          keyedDetails.description.text &&
          <BkFlowEnhancementsCardDescription
            hotelLabels={hotelLabels}
            serviceDescription={keyedDetails.description.text}
            serviceDescriptionExpanded={serviceDescriptionExpanded}
            limitChars={100}
            serviceDescriptionEvent={() => handleToggleServiceDescription()}
          />
        }
      </div>

      <div className="bk-flow-enhancements__card-details">
        { enhancementPrice ?
          <div className="bk-flow-enhancements__card-price">
            <h2 className="price-value">
              { currencySymbol && <span className="currency-symbol">{currencySymbol}</span>}
              <span className="price-label">
                { formatPrice(enhancementPrice, 2, true)}
                { enhancementCardType[enhancementKey].servicePricingType && <span className="price-frequency">{enhancementCardType[enhancementKey].servicePricingType}</span>}
              </span>
            </h2>
          </div>
        :
            <div className="bk-flow-enhancements__card-price">
              <h2 className="price-value">
                <span className="price-label">--</span>
              </h2>
            </div>
        }

        <BkFlowRoomEnhancementButton
          enhancementKey={currentEnhancementKey}
          enhancementApiData={enhancementCardType[enhancementKey]}
          isEnhancementSelected={isEnhancementSelected}
          roomGroup={roomGroupKey}
          roomType={activeRoom[roomGroupKey][0][0].roomTypeCode}
          ratePlanCode={activeRoom[roomGroupKey][1][0].ratePlanCode}
        />
      </div>
    </div>
  )
}

export default BkFlowEnhancementsCardFull



// WEBPACK FOOTER //
// ./src/components/enhancements/layouts/BkFlowEnhancementsCardFull.js